import React from 'react';

export default function EventCard({ eventData }) {
  const { date, month, title, time, themeColor, ctaLink, iconLayout } = eventData || {};

  const handleRegisterClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const target = ctaLink || '#register';

    if (target.startsWith('#')) {
      window.location.hash = target;
      return;
    }

    window.location.href = target;
  };

  return (
    <div className="live-event-card-container">
      
      
      <div className="event-card-top-layout-block">
        
       
        <div 
          className="event-calendar-date-badge" 
          style={{ 
            borderColor: themeColor || '#0052FF', 
            color: themeColor || '#0052FF' 
          }}
        >
          <span className="event-badge-day-num">{date || "01"}</span>
          <span className="event-badge-month-text">{month || "JAN"}</span>
        </div>

        
        <div className="event-card-core-text-block">
          <h4 className="event-card-title-header">{title || "Live Workshop Title"}</h4>
          <p className="event-card-timestamp-text">
            <span className="clock-icon-vector">🕒</span> {time || "7:00 PM IST"}
          </p>
        </div>

        
        <div className="event-card-right-graphics-node">
          {iconLayout}
        </div>

      </div>

      
      <a 
        href={ctaLink || "#register"} 
        className="event-card-register-action-btn"
        onClick={handleRegisterClick}
      >
        Register Now ➔
      </a>

    </div>
  );
}